<template>

    <div class="step" :class="{ expanded: this.step === this.selectedStep }">
        <div class="step-header" @click="selectStep">
            <v-step-number :step-number="step" />
            <span>{{ title }}</span>
        </div>
        <div v-if="step === selectedStep">
            <div class="step-body">
                <slot></slot>
            </div>
            <div v-if="$slots['footer']" class="step-footer">
                <slot name="footer"></slot>
            </div>
            <div v-else class="step-footer">
                <v-button size="sm" :loading="loading" @click.native="updateCampaign">Save &amp; Continue</v-button>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .step {
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 5px;
        margin-bottom: 10px;
        transition: border .3s;
        &:hover {
            border-color: $color-text;
        }
        &.expanded {
            border-color: $color-primary;
            .step-header {
                color: $color-primary;
            }
        }
        .step-header {
            @include font-medium(16px);
            align-items: center;
            color: $color-text;
            cursor: pointer;
            display: flex;
            padding: 20px;
            transition: color .3s;
            user-select: none;
        }
        .step-body {
            border-top: 1px solid $color-rule;
        }
        .step-footer {
            border-top: 1px solid $color-rule;
            display: flex;
            justify-content: space-between;
            padding: 15px;
            *:only-child {
                margin-left: auto;
            }
        }
    }

</style>

<script>

import CampaignApi from '@api/CampaignApi';

export default {

    props: {
        step: {
            type: Number,
            default: 1,
        },
        title: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
        }
    },

    computed: {

        selectedStep() {
            return this.$store.getters['campaign/step'];
        },

        campaign() {
            return this.$store.getters['campaign/campaign'];
        },

    },

    methods: {

        selectStep() {
            this.$store.commit('campaign/setStep', this.step);
        },

        updateCampaign() {
            this.loading = true;
            let step = this.title.toLowerCase();
            if (step === 'trigger' && this.campaign.trigger) {
                this.campaign.trigger.rules = this.$store.getters['segmenter/rules'];
            } else if (step === 'goal' && this.campaign.goal) {
                this.campaign.goal.rules = this.$store.getters['segmenter/rules'];
            }
            CampaignApi.updateCampaign(this.campaign.id, this.campaign, step)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('campaign/setStep', this.step + 1);
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
